/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_Management_SubtitleInputs */

const en_user_management_subtitle = /** @type {(inputs: User_Management_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage app users and permissions`)
};

const ja_user_management_subtitle = /** @type {(inputs: User_Management_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アプリユーザーと権限を管理`)
};

const fr_user_management_subtitle = /** @type {(inputs: User_Management_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gérer les utilisateurs et les permissions`)
};

const de_user_management_subtitle = /** @type {(inputs: User_Management_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`App-Benutzer und Berechtigungen verwalten`)
};

/**
* | output |
* | --- |
* | "Manage app users and permissions" |
*
* @param {User_Management_SubtitleInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const user_management_subtitle = /** @type {((inputs?: User_Management_SubtitleInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_Management_SubtitleInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_user_management_subtitle(inputs)
	if (locale === "ja") return ja_user_management_subtitle(inputs)
	if (locale === "fr") return fr_user_management_subtitle(inputs)
	return de_user_management_subtitle(inputs)
});